<template>
  <span class="helper-text">{{ helper }}</span>
</template>

<script lang="ts">
import { formatDuration, intervalToDuration } from "date-fns";
import { cloneDeep } from "lodash-es";
import { computed, defineComponent, PropType, toRefs } from "vue";

import { RoutineMandateCompletion } from "@ctrl/controller-rpc";

export default defineComponent({
  props: {
    completion: {
      type: Object as PropType<RoutineMandateCompletion>,
      required: true,
    },
    start: { type: Date, required: true },
    end: { type: Date, required: true },
  },
  setup(props) {
    const { completion, start, end } = toRefs(props);
    const completionValue = completion.value.value;
    const helper = computed(() => {
      if (completionValue?.type === "daytime") {
        const newEnd = cloneDeep(end.value);
        newEnd.setHours(completionValue.value.hours);
        newEnd.setMinutes(completionValue.value.minutes || 0);
        if (start.value < newEnd) {
          const duration = intervalToDuration({
            start: start.value,
            end: newEnd,
          });
          return formatDuration(duration, {
            format: ["days", "hours", "minutes"],
          });
        }
      }
      return "";
    });
    return { helper };
  },
});
</script>
